import { render, staticRenderFns } from "./task_allocate.vue?vue&type=template&id=1f815406&scoped=true"
import script from "./task_allocate.vue?vue&type=script&lang=js"
export * from "./task_allocate.vue?vue&type=script&lang=js"
import style0 from "./task_allocate.vue?vue&type=style&index=0&id=1f815406&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f815406",
  null
  
)

export default component.exports